import styled from "styled-components";

import { CircularImg } from "components/Img";

const HeadshotWrapper = styled.div`
  width: 60px;
  height: 60px;
  min-width: 60px;
  min-height: 60px;
`;

export function Headshot({
  image,
  alt,
  ...props
}: {
  image: string;
  alt: string;
}): React.ReactElement {
  return (
    <HeadshotWrapper {...props}>
      <CircularImg src={image} alt={alt} />
    </HeadshotWrapper>
  );
}
